import React, { useState } from "react";
import moment from "moment";

function SalesCard({ item, index }) {
  const [isFlipped, setIsFlipped] = useState(false);

  const handleFlip = () => {
    setIsFlipped((prev) => !prev);
  };

  // Safe image source handling
  const imageSrc =
    item?.isImageUrl === true
      ? item?.image_path
      : (item?.url_image || "") + (item?.image_path || "");

  // Safe datetime formatting
  const formattedDateTime = item?.datetime
    ? moment(item.datetime.split(".")[0].replace(" ", "T")).format(
        "DD/MM/YYYY HH:mm"
      )
    : null;

  const [date, time] = formattedDateTime
    ? formattedDateTime.split(" ")
    : ["", ""];

  return (
    <div className="col-sm-3">
      <div
        className={`product-card ${isFlipped ? "flipped" : ""}`}
        onClick={handleFlip}
      >
        <div className="card-inner">
          <div className="card-front">
            <div className="image-container">
              <img
                src={imageSrc}
                alt={`product-${index}`}
                onError={(e) => {
                  e.target.src = "/no-image.png";
                }}
              />
            </div>

            <div className="text-container">
              <p className="cart-card-category">{item?.entry_no || "N/A"}</p>

              {formattedDateTime && (
                <div className="cart-card-date">
                  <span>{date}</span>
                  <span>{time}</span>
                </div>
              )}
            </div>
          </div>

          <div
            className="card-back"
            style={{ display: isFlipped ? "flex" : "none" }}
          >
            <div className="cart-card-details">
              <p className="cart-card-details-title">Additional Details</p>
              <ul>
                <li>
                  <span>Product</span>
                  <b>{item?.product_name || "N/A"}</b>
                </li>
                <li>
                  <span>Category</span>
                  <b>{item?.category_name || "N/A"}</b>
                </li>
                <li>
                  <span>Sub Category</span>
                  <b>{item?.sub_category_name || "N/A"}</b>
                </li>
                <li>
                  <span>Invoice</span>
                  <b>{item?.entry_no || "N/A"}</b>
                </li>
                <li>
                  <span>Date</span>
                  <b>{formattedDateTime || "N/A"}</b>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SalesCard;
